module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-area container"
  }, [_c('div', {
    staticClass: "operation-btn-area row text-center mb-4"
  }, [_c('div', {
    staticClass: "offset-2 offset-lg-4 col-8 col-lg-4 py-4"
  }, [_c('div', {
    staticClass: "my-4"
  }, [_c('h3', {
    staticClass: "h6 font-size-1 mb-1"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][1]"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn w-100 page-btn btn-lg btn-warning",
    attrs: {
      "tag": "button",
      "to": {
        name: 'demo-signup',
        params: {}
      },
      "type": "button"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][2]"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "my-4"
  }, [_c('h3', {
    staticClass: "h6 font-size-1 mb-1"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][3]"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    staticClass: "btn w-100 page-btn btn-lg btn-danger",
    attrs: {
      "tag": "button",
      "type": "button",
      "to": {
        name: 'demo-login',
        params: {}
      }
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][4]"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "news-area row"
  }, [_c('div', {
    staticClass: "offset-lg-2 col-lg-8"
  }, [_c('h3', {
    staticClass: "news-head h5 font-size-1 mb-0 text-center relative"
  }, [_c('span', {
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][5]"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "w-100 news-head-bg-line my-0"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-100 news-head-bg-line-center my-0"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "news-content border-top-0 py-2 px-3"
  }, [_c('li', {
    staticClass: "list-unstyled text-left"
  }, [_c('h6', {
    staticClass: "font-weight-bold font-size-md-08-down mb-1"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][101]"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "mb-1 font-size-md-07-down"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][102]"
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-image-area container-fluid px-0"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/top_image.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9a228e22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/DemoTop.vue
// module id = 723
// module chunks = 0